export default [
  {
    login: "Arnav02",
    id: 60700183,
    node_id: "MDQ6VXNlcjYwNzAwMTgz",
    avatar_url: "https://avatars.githubusercontent.com/u/60700183?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/Arnav02",
    html_url: "https://github.com/Arnav02",
    followers_url: "https://api.github.com/users/Arnav02/followers",
    following_url:
      "https://api.github.com/users/Arnav02/following{/other_user}",
    gists_url: "https://api.github.com/users/Arnav02/gists{/gist_id}",
    starred_url: "https://api.github.com/users/Arnav02/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/Arnav02/subscriptions",
    organizations_url: "https://api.github.com/users/Arnav02/orgs",
    repos_url: "https://api.github.com/users/Arnav02/repos",
    events_url: "https://api.github.com/users/Arnav02/events{/privacy}",
    received_events_url: "https://api.github.com/users/Arnav02/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "aashishchachan",
    id: 63456605,
    node_id: "MDQ6VXNlcjYzNDU2NjA1",
    avatar_url: "https://avatars.githubusercontent.com/u/63456605?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/aashishchachan",
    html_url: "https://github.com/aashishchachan",
    followers_url: "https://api.github.com/users/aashishchachan/followers",
    following_url:
      "https://api.github.com/users/aashishchachan/following{/other_user}",
    gists_url: "https://api.github.com/users/aashishchachan/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/aashishchachan/starred{/owner}{/repo}",
    subscriptions_url:
      "https://api.github.com/users/aashishchachan/subscriptions",
    organizations_url: "https://api.github.com/users/aashishchachan/orgs",
    repos_url: "https://api.github.com/users/aashishchachan/repos",
    events_url: "https://api.github.com/users/aashishchachan/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/aashishchachan/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "mairalvinit",
    id: 60435807,
    node_id: "MDQ6VXNlcjYwNDM1ODA3",
    avatar_url: "https://avatars.githubusercontent.com/u/60435807?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/mairalvinit",
    html_url: "https://github.com/mairalvinit",
    followers_url: "https://api.github.com/users/mairalvinit/followers",
    following_url:
      "https://api.github.com/users/mairalvinit/following{/other_user}",
    gists_url: "https://api.github.com/users/mairalvinit/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/mairalvinit/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/mairalvinit/subscriptions",
    organizations_url: "https://api.github.com/users/mairalvinit/orgs",
    repos_url: "https://api.github.com/users/mairalvinit/repos",
    events_url: "https://api.github.com/users/mairalvinit/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/mairalvinit/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "RutvijDv",
    id: 61192557,
    node_id: "MDQ6VXNlcjYxMTkyNTU3",
    avatar_url: "https://avatars.githubusercontent.com/u/61192557?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/RutvijDv",
    html_url: "https://github.com/RutvijDv",
    followers_url: "https://api.github.com/users/RutvijDv/followers",
    following_url:
      "https://api.github.com/users/RutvijDv/following{/other_user}",
    gists_url: "https://api.github.com/users/RutvijDv/gists{/gist_id}",
    starred_url: "https://api.github.com/users/RutvijDv/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/RutvijDv/subscriptions",
    organizations_url: "https://api.github.com/users/RutvijDv/orgs",
    repos_url: "https://api.github.com/users/RutvijDv/repos",
    events_url: "https://api.github.com/users/RutvijDv/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/RutvijDv/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "hiren-2911",
    id: 58786896,
    node_id: "MDQ6VXNlcjU4Nzg2ODk2",
    avatar_url: "https://avatars.githubusercontent.com/u/58786896?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/hiren-2911",
    html_url: "https://github.com/hiren-2911",
    followers_url: "https://api.github.com/users/hiren-2911/followers",
    following_url:
      "https://api.github.com/users/hiren-2911/following{/other_user}",
    gists_url: "https://api.github.com/users/hiren-2911/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/hiren-2911/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/hiren-2911/subscriptions",
    organizations_url: "https://api.github.com/users/hiren-2911/orgs",
    repos_url: "https://api.github.com/users/hiren-2911/repos",
    events_url: "https://api.github.com/users/hiren-2911/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/hiren-2911/received_events",
    type: "User",
    site_admin: false,
  },
  {
    login: "HarshMi51",
    id: 63901112,
    node_id: "MDQ6VXNlcjYzOTAxMTEy",
    avatar_url: "https://avatars.githubusercontent.com/u/63901112?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/HarshMi51",
    html_url: "https://github.com/HarshMi51",
    followers_url: "https://api.github.com/users/HarshMi51/followers",
    following_url:
      "https://api.github.com/users/HarshMi51/following{/other_user}",
    gists_url: "https://api.github.com/users/HarshMi51/gists{/gist_id}",
    starred_url:
      "https://api.github.com/users/HarshMi51/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/HarshMi51/subscriptions",
    organizations_url: "https://api.github.com/users/HarshMi51/orgs",
    repos_url: "https://api.github.com/users/HarshMi51/repos",
    events_url: "https://api.github.com/users/HarshMi51/events{/privacy}",
    received_events_url:
      "https://api.github.com/users/HarshMi51/received_events",
    type: "User",
    site_admin: false,
  },
];
